import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { Product } from '~shared/models';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';

export interface ViewItemListApplicationEventPayload {
  pageName: string;
  products: Product[];
  priceType: PriceTypes;
  currency: string;
  startingIndex: number;
  searchTerm: string;
  isPlp: boolean;
}

export class ViewItemListApplicationEventModel implements ApplicationEvent {
  type = ApplicationEventType.ViewItemsList;

  constructor(
    private pageName: string,
    private products: Product[],
    private priceType: PriceTypes,
    private currency: string,
    private startingIndex?: number,
    private searchTerm?: string,
    private isPlp?: boolean
  ) {}

  getPayload(): ViewItemListApplicationEventPayload {
    return {
      pageName: this.pageName,
      products: this.products,
      priceType: this.priceType,
      currency: this.currency,
      startingIndex: this.startingIndex,
      searchTerm: this.searchTerm,
      isPlp: this.isPlp,
    };
  }
}
